import React from 'react'
import renderInputField from 'components/FormControls/textInput'
import { useTranslation } from 'react-i18next'
import { Field } from 'redux-form'
import TaxNumberField from 'modules/Forms/Finance/PaymentProfileCreate/subcomponents/TaxNumberField'
import renderMaskedInput from 'components/FormControls/maskedInputField'
import phoneFieldNormalize from 'utils/normalize/phoneFieldNormalize'
import phoneMask from 'utils/constants/phoneMask'
import PropTypes from 'prop-types'

const PersonalRu = ({ form, disabled = false }) => {
  const { t } = useTranslation()

  return (
    <>
      <div className={'margin-bottom-16'}>
        <Field
          disabled={disabled}
          fullWidth
          name="details.lastname"
          component={renderInputField}
          label={t('payment_profiles::new.fields.details.lastname.label')}
          t={t}
        />
      </div>

      <div className={'margin-bottom-16'}>
        <Field
          disabled={disabled}
          fullWidth
          name="details.firstname"
          component={renderInputField}
          label={t('payment_profiles::new.fields.details.firstname.label')}
          t={t}
        />
      </div>

      <div className={'margin-bottom-16'}>
        <Field
          disabled={disabled}
          fullWidth
          name="details.middle_name"
          component={renderInputField}
          label={t('payment_profiles::new.fields.details.middle_name.label')}
          t={t}
        />
      </div>

      <div className={'margin-bottom-16'}>
        <TaxNumberField form={form} disabled={disabled} />
      </div>

      <div className={'margin-bottom-16'}>
        <Field
          disabled={disabled}
          fullWidth
          normalize={phoneFieldNormalize}
          name="details.phone"
          component={renderMaskedInput}
          placeholderChar={'\u2002'}
          placeholder={'+ ( )'}
          mask={phoneMask}
          label={t('payment_profiles::new.fields.details.phone.label')}
          t={t}
        />
      </div>
    </>
  )
}

export default PersonalRu

PersonalRu.propTypes = {
  form: PropTypes.string,
  disabled: PropTypes.bool,
}
